<template>
  <div
    :style="{...fullPaddingSubject(section.options.content.carousel, 'padding', [20,20,20,20]), ...fullMarginSubject(section.options.content.carousel)}"
    class="d-flex justify-center"
  >
    <slot />
  </div>
</template>

<script>
import TemplateMixin from '@builder/components/mixins/TemplateMixin'
import BorderMixin from '@/components/mixins/BorderMixin'

export default {
  name: 'ImageItem1Template',
  mixins: [TemplateMixin, BorderMixin]
}
</script>
